import { render, staticRenderFns } from "./DashboardSocialMedia.vue?vue&type=template&id=4a7f6bcb&"
import script from "./DashboardSocialMedia.vue?vue&type=script&lang=js&"
export * from "./DashboardSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports